import { PagingResultsViewModel, FilterSearchingBaseViewModel, EnumSiNoTodos } from 'src/app/components/core/_infrastructure/types/common';

export class PanelProductosViewModel {
    public Id: number | null;
    public IdSolicitud: number;
    public CodigoSolicitud: '';
    public CodigoTaric: '';
    public CodigoEppo: '';
    public NombreComun: '';
    public IdTipoErrorTracesProducto: number;
    public DescripcionTipoErrorTracesProducto: '';
    public FechaCreacion: Date;
    public FechaAltaTraces: Date | null;
    public AltaTraces: boolean;
}

export class PanelProductosItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: PanelProductosItemViewModel[];
}

export class PanelProductosItemViewModel {
    public Id: number;
    public IdSolicitud: number;
    public CodigoSolicitud: '';
    public CodigoTaric: '';
    public CodigoEppo: '';
    public NombreComun: '';
    public IdTipoErrorTracesProducto: number;
    public DescripcionTipoErrorTracesProducto: '';
    public FechaCreacion: Date;
    public FechaAltaTraces: Date | null;
    public AltaTraces: boolean;
}

export class FilterSearchingPanelProductosViewModel extends FilterSearchingBaseViewModel {
    public NombreComun: '';
    public CodigoSolicitud: '';
    public CodigoTaric: '';
    public CodigoEppo: '';
    public IdTipoErrorTracesProducto: number;
    public FechaDesde: Date | null;
    public FechaHasta: Date | null;
    public AltaTraces: number = EnumSiNoTodos.TODOS;
}
